import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {NumberFormat,MobileFormat,DateThaiFormat,DateFormat,DateThai,GetRole} from '../../Utils/Function';
import {RoleName,RoleList} from '../../Utils/Status';
import { createRoot } from 'react-dom/client';
import {UserInfoCard} from '../../Components/User';
import Swal from 'sweetalert2';
import API from '../../API';
import "react-datepicker/dist/react-datepicker.css";
import '../../Assets/CSS/TALFC.css';

const PageUserList =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();

    const ref = useRef();
    const _UserInfoCard = useRef();
    const [GroupList,setGroupList] = useState([]);

    useEffect(() => {
        (async () => {
        })();

        return ()=>{ }
    }, []);

    const _configs = {
        "order": [[0, "desc"]],
        pageLength: 25,
        orderMulti: true
    }
    const _ajax  = {
        'url': '/Admin/User/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.Role = getValues('Role');
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' title='รายละเอียด' className='btn btn-info text-white' onClick={() => _UserInfoCard.current?.Show(d)}>Info</button>
        </div>
    )
    const _column = [
        { data: "Username", name: "Username", autoWidth: true },
        { data: "Name", name: "Name", autoWidth: true },
        { data: "Role", name: "Role", autoWidth: true,render(data){
            return RoleName(data);
        } },
        { data: "Status", name: "Status", autoWidth: true,render(data){
            switch(data){
                case 1 : return "<span className='badge fs-6  bg-success'>เปิด</span>";
                case 0: return "<span className='badge fs-6  bg-danger'>ปิด</span>";
                default : return "-";
            }
        } }, 
        {data: "Updated", name: "Updated", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        {
            data: "UserId", name: "UserId", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    const _UpdateTable =()=>{
        ref.current?.load();
    }

    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                    <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>จัดการเจ้าหน้าที่</h3>
                            </div>
                            <div className='card-body' style={{'minHeight':'300px'}}>
                            <div className='row d-flex justify-content-end'>
                                <div className='col-12 col-lg-4 text-end'>
                                    <div className='input-group float-end'>
                                        <select className='form-control text-center' {...register("Role", { required: false })} defaultValue={0} onChange={(e)=>{setValue("Role",e.target.value);setTimeout(()=>{ref.current.load();},200)}} >
                                            <option value={0} selected>ทั้งหมด</option>
                                            {RoleList.map((v,i)=>{
                                                return <option key={i} value={v}>{RoleName(v)}</option>
                                            })}
                                        </select>
                                        <div className='btn btn-group'>
                                            <button type='button' className='btn btn-danger text-white' onClick={()=>{_UserInfoCard.current?.Show(null);}}>เพิ่มเจ้าหน้าที่</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                                <div className='row'>
                                    <div className="col-lg-12 table-responsive">
                                        <table id="UserTableView" className='table w-100' role='grid'>
                                            <thead>
                                                <tr>
                                                    <th className="text-center textcenter">รหัสผู้ใช้งาน</th>
                                                    <th className="text-center textcenter">ชื่อ</th>
                                                    <th className="text-center textcenter">สิทธิ์</th>
                                                    <th className="text-center textcenter">สถานะ</th>
                                                    <th className="text-center textcenter">วันที่แก้ไข</th>
                                                    <th className="text-center no-sort"></th>
                                                </tr>
                                            </thead>
                                            <DataTable TableID={"UserTableView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UserInfoCard ref={_UserInfoCard}  update={()=>{ref.current?.load();}}/>
        </React.Fragment>
        </>
    )
}

export default React.memo(PageUserList)
